import React from "react";
import { Stack } from "@chakra-ui/react";
import { Layout } from "../../components/Layout";
import AccountAuthSection from "./AccountAuthSection";
import SubscriptionBillingSection from "./SubscriptionBillingSection";
import DangerZoneSection from "./DangerZoneSection";

const Settings: React.FC = () => {
  return (
    <Layout behavior="dashboard" showFooter>
      <Stack gap={4}>
        <AccountAuthSection />
        <SubscriptionBillingSection />
        <DangerZoneSection />
      </Stack>
    </Layout>
  );
};

export default Settings;
